import styled, { css } from "styled-components"

const IconColor = css`
  fill: ${props => (props.color ? props.color : props.theme.color.black)};
`

const IconStroke = css`
  stroke: ${props => (props.color ? props.color : props.theme.color.black)};
`

export const IconWrapper = styled.svg`
  width: ${props => (props.width ? props.width : "auto")};
  height: ${props => (props.height ? props.height : "auto")};
  z-index: 2;
`
export const IconPath = styled.path`
  ${IconColor}
`
export const IconPathAnimated = styled.path`
  ${IconColor}
  transition: fill 0.5s ease-in-out;
`

export const IconCircle = styled.circle`
  ${IconColor}
`
export const IconPolygon = styled.polygon`
  ${IconColor}
`

export const IconRect = styled.rect`
  ${IconColor}
`

export const IconPathStroke = styled.path`
  ${IconStroke}
`
export const IconCircleStroke = styled.circle`
  ${IconStroke}
`
export const IconPolygonStroke = styled.polygon`
  ${IconStroke}
`

export const IconRectStroke = styled.rect`
  ${IconStroke}
`
